// extracted by mini-css-extract-plugin
export default {"cardTable":"CardItemPedido_cardTable__zKQSI"};